import Chart from "artifact/chart";
import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import didPaint from "standard/didPaint";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-student-performance-watched")
class Student extends HTMLElement {
  #online;
  #watched;
  #size;
  #video;
  #result;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  get [trait.online]() {
    return (this.#online ??= this.shadowRoot.getElementById("online"));
  }

  get [trait.watched]() {
    return (this.#watched ??= []);
  }

  get [trait.size]() {
    return (this.#size ??= []);
  }

  get [trait.video]() {
    return (this.#video ??= []);
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <section class='${style.performance}'>
        <canvas id="online" />
      </section>
    `;
  }

  @willPaint
  async [trait.fetch]() {
    const { count: watched } = await supabase
      .from("video_completed")
      .select("*", { count: "exact", head: true })
      .eq("user_id", this.dataset.user);

    const { count: video } = await supabase
      .from("video")
      .select("*, academy(*, level_of_education(*, grade(*)))", {
        count: "exact",
        head: true,
      })
      .eq("academy.level_of_education.grade.school_id", this.dataset.school);

    this.#video = video;
    this.#size = watched;
    this.#result = Math.floor((watched / video) * 100);
  }

  @didPaint
  [trait.chart]() {
    const doughnutLabel = {
      id: "doughnutLabel",
      beforeDatasetsDraw: (chart) => {
        const { ctx } = chart;

        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        ctx.font = "bold 30px sans-serif";
        ctx.fillStyle = "#444444";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.sizeText = 40;
        ctx.font = "60px sans-serif";
        ctx.fillText(`${this.#result}%`, xCoor, yCoor);
      },
    };

    const ctx = this[trait.online].getContext("2d");
    const gradientSegment = ctx.createLinearGradient(0, 0, 700, 0);
    gradientSegment.addColorStop(0, "#0EB4B7");
    gradientSegment.addColorStop(0.7, "#08D788");
    gradientSegment.addColorStop(1, "#0EB4B7");
    const myChart = new Chart(this[trait.online], {
      type: "doughnut",
      data: {
        datasets: [
          {
            data: [`${this.#size}`, `${this.#video}`],
            backgroundColor: [gradientSegment, "#EEEEEE"],
          },
        ],
      },
      options: {
        cutout: "70%",
        borderRadius: 60,
      },
      plugins: [doughnutLabel],
    });
    return this;
  }
}

export default Student;
